import { combineReducers } from "redux"

import list from "./list/slice"
import add from "./add/slice"
import item from "./item/slice"
import update from "./update/slice"
import remove from "./remove/slice"

const staticPagesReducer = combineReducers({
  list,
  add,
  item,
  update,
  remove,
})

export default staticPagesReducer
